import {
  curry,
  drop,
  dropRight,
  findIndex,
  first,
  isEqual,
  last,
} from 'lodash';

export const nonMutatingReverse = list => list.slice().reverse();

export const filterEqualPositions = curry((compareList, sourceList) =>
  sourceList.filter((item, index) => isEqual(item, compareList[index])),
);

export const filterEqualRightPositions = curry((compareList, sourceList) =>
  filterEqualPositions(
    nonMutatingReverse(compareList),
    nonMutatingReverse(sourceList),
  ).reverse(),
);

export const addItemRight = compareList => sourceList => {
  if (!sourceList.length) {
    return sourceList;
  }

  const index = findIndex(compareList, last(sourceList));

  return index === compareList.length - 1
    ? sourceList
    : [...sourceList, compareList[index + 1]];
};

export const addItemLeft = compareList => sourceList => {
  if (!sourceList.length) {
    return sourceList;
  }

  const index = findIndex(compareList, first(sourceList));

  return index === 0 ? sourceList : [compareList[index - 1], ...sourceList];
};

export const dropFirstItem = compareList => sourceList => {
  return first(sourceList) === first(compareList)
    ? drop(sourceList)
    : sourceList;
};

export const dropLastItem = compareList => sourceList => {
  return last(sourceList) === last(compareList)
    ? dropRight(sourceList)
    : sourceList;
};
